var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Annonce } from 'annonce/classes/Annonce.class';
import axiosInstance from '../../store/AxiosSingleton';
import { AnnonceCategorie } from 'annonce/classes/AnnonceCategorie.class';
import { Membre } from 'membre/classes/Membre.class';
export class AnnonceService {
    /**
     * Insère une annonce
     * @param annonce L'annonce à insérer
     * @return L'annonce inséré
     */
    static save(annonce) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { annonce: annonce.toRaw() }, {
                params: {
                    rub: AnnonceService.rubModule,
                    action: 'SAVE_ANNONCE',
                },
            });
            if (content === null) {
                return null;
            }
            return new Annonce(content);
        });
    }
    /**
     * Récupère les annonces selon des filtres
     * @param params Les paramètres de la recherche
     * @return La liste des annonces
     */
    static loadAnnonces(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AnnonceService.rubModule,
                    action: 'LOAD_ANNONCES',
                    params,
                },
            });
            if (content === null) {
                return null;
            }
            return {
                annonces: content.annonces.map((annonce) => new Annonce(annonce)),
                total: content.total,
            };
        });
    }
    /**
     * Récupère une annonce en fonction de son identifiant
     * @param idAnnonce Identifiant de l'annonce
     * @return L'annonce
     */
    static loadAnnonce(idAnnonce) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AnnonceService.rubModule,
                    action: 'LOAD_ANNONCE',
                    idAnnonce,
                },
            });
            if (content === null) {
                return null;
            }
            return new Annonce(content);
        });
    }
    /**
     * Récupère les catégories des annonces
     * @return Les catégories
     */
    static loadCategories() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AnnonceService.rubModule,
                    action: 'LOAD_ALL_CATEGORIES',
                },
            });
            if (content === null) {
                return null;
            }
            return content.map((categorie) => new AnnonceCategorie(categorie));
        });
    }
    /**
     * Récupère les annonces du membre
     * @param params Filtre de la recherche
     * @return Les annonces
     */
    static loadAnnoncesFromMembre(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    params,
                    rub: AnnonceService.rubModule,
                    action: 'LOAD_ANNONCES_FROM_MEMBRE',
                },
            });
            if (content === null) {
                return { annonces: [], total: 0 };
            }
            return {
                annonces: content.annonces.map((annonce) => new Annonce(annonce)),
                total: content.total,
            };
        });
    }
    /**
     * Récupère les annonces du membre
     * @param params Filtre de la recherche
     * @return Les annonces
     */
    static loadAnnoncesPremiumFromMembre(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    params,
                    rub: AnnonceService.rubModule,
                    action: 'LOAD_ANNONCES_PREMIUM_FROM_MEMBRE',
                },
            });
            if (content === null) {
                return { annonces: [], total: 0 };
            }
            return {
                annonces: content.annonces.map((annonce) => new Annonce(annonce)),
                total: content.total,
            };
        });
    }
    /**
     * Récupère les catégorie en vogue
     * @return Les catégories
     */
    static loadCategoriesEnVogue() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AnnonceService.rubModule,
                    action: 'LOAD_CATEGORIES_EN_VOGUE',
                },
            });
            if (content === null) {
                return [];
            }
            return content.map((categorie) => new AnnonceCategorie(categorie));
        });
    }
    /**
     * Récupère les dernières annonces
     * @return Les catégories
     */
    static loadLastAnnonces() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AnnonceService.rubModule,
                    action: 'LOAD_LAST_ANNONCES',
                },
            });
            if (content === null) {
                return [];
            }
            return content.map((annonce) => new Annonce(annonce));
        });
    }
    /**
     * Récupère les contacts qui ont posté le plus d'annonces
     * @return Les contacts
     */
    static loadContactsWithMostAnnonces() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AnnonceService.rubModule,
                    action: 'LOAD_CONTACTS_MOST_ANNONCES',
                },
            });
            if (content === null) {
                return [];
            }
            return content.map((membre) => new Membre(membre.infoPublic));
        });
    }
    /**
     * Récupère les contacts qui ont posté le plus d'annonces
     * @return Les contacts
     */
    static loadAnnoncesFromContacts() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AnnonceService.rubModule,
                    action: 'LOAD_ANNONCES_FROM_CONTACTS',
                },
            });
            if (content === null) {
                return [];
            }
            return content.map((annonce) => new Annonce(annonce));
        });
    }
    /**
     * Récupère les annonces les plus proches du membre connecté
     * @return Les annonces
     */
    static loadClosestAnnonces() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AnnonceService.rubModule,
                    action: 'LOAD_CLOSEST_ANNONCES',
                },
            });
            if (content === null) {
                return [];
            }
            return content.map((annonce) => new Annonce(annonce));
        });
    }
    /**
     * Récupère les annonces similaire à celle passé en paramètre
     * @param idAnnonce Identifiant de l'annonce
     * @returns Les annonces
     */
    static loadSimilarAnnonces(idAnnonce) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    idAnnonce,
                    rub: AnnonceService.rubModule,
                    action: 'LOAD_SIMILAR_ANNONCES',
                },
            });
            if (content === null) {
                return [];
            }
            return content.map((annonce) => new Annonce(annonce));
        });
    }
    /**
     * Booste une annonce
     * @param idAnnonce Identifiant de l'annonce
     * @returns L'annonce
     */
    static boosterAnnonce(idAnnonce) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    idAnnonce,
                    rub: AnnonceService.rubModule,
                    action: 'BOOSTER_ANNONCE',
                },
            });
            if (content === null) {
                return null;
            }
            return new Annonce(content);
        });
    }
    /**
     * Récupère le nombre total d'annonces en ligne
     * @returns Le nombre d'annonces
     */
    static loadTotalAnnonces() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AnnonceService.rubModule,
                    action: 'LOAD_TOTAL_ANNONCES',
                },
            });
            if (content === null) {
                return 0;
            }
            return content;
        });
    }
}
AnnonceService.rubModule = 'annonce';
//# sourceMappingURL=data:application/json;base64,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